import {
    CORE_INTEGRATION_O365_ADD_CLIENT_ID,
    CORE_INTEGRATION_O365_ADMIN_CONSENT,
    // CORE_INTEGRATION_O365_REQUEST,
    CORE_INTEGRATION_O365_SUCCESS,
    CORE_INTEGRATION_O365_FAILURE,

    CORE_INTEGRATION_O365_GO_ADD_CLIENT_ID,
    CORE_INTEGRATION_O365_GO_ADMIN_CONSENT,
    CORE_INTEGRATION_O365_GO_SAVE_DATA,

    CORE_GET_INTEGRATION_REQUEST,
    CORE_GET_INTEGRATION_SUCCESS,

    CORE_GET_INTEGRATION_INFO_REQUEST,
    CORE_GET_INTEGRATION_INFO_SUCCESS,
} from '../../../types'

const noMessage = {
    success: "",
    error: ""
}
const initialState = {
    step: 1,
    o365: {
        tenant_id: "",
        client_id: ""
    },
    ...noMessage
}

export default {
    initialState: (state = initialState, action) => {
        switch (action.type) {

            case CORE_INTEGRATION_O365_GO_ADD_CLIENT_ID: {
                return initialState
            }

            case CORE_INTEGRATION_O365_GO_ADMIN_CONSENT: {
                const { step, client_id } = action.payload
                return {
                    step,
                    o365: {
                        ...state.o365,
                        client_id
                    },
                    ...noMessage
                }
            }

            case CORE_INTEGRATION_O365_GO_SAVE_DATA: {
                const { step, client_id, tenant_id } = action.payload
                return {
                    step,
                    o365: {
                        tenant_id,
                        client_id
                    },
                    ...noMessage
                }
            }

            case CORE_INTEGRATION_O365_ADD_CLIENT_ID: {
                const { step, client_id } = action.payload
                return {
                    step,
                    o365: {
                        ...state.o365,
                        client_id
                    },
                    ...noMessage
                }
            }

            case CORE_INTEGRATION_O365_ADMIN_CONSENT: {
                const { step, tenant_id } = action.payload
                return {
                    step,
                    o365: {
                        ...state.o365,
                        tenant_id
                    },
                    ...noMessage
                }
            }
            case CORE_INTEGRATION_O365_SUCCESS:
                return {
                    ...initialState,
                    success: "Connect Successfully"
                }

            case CORE_INTEGRATION_O365_FAILURE:
                return {
                    ...initialState,
                    step: 3,
                    success: "",
                    error: "Connect failed. Please check your data"
                }
            default:
                return state
        }
    },
    ini: (state = initialState, action) => {
        switch (action.type) {
            case CORE_GET_INTEGRATION_REQUEST:
                return initialState

            case CORE_GET_INTEGRATION_SUCCESS:
                return action.payload
            default:
                return state
        }
    },
    integrationInfo: (state = initialState, action) => {
        switch (action.type) {
            case CORE_GET_INTEGRATION_INFO_REQUEST:
                return initialState

            case CORE_GET_INTEGRATION_INFO_SUCCESS:
                return action.payload
            default:
                return state
        }
    },
}


// WEBPACK FOOTER //
// ./src/features/settings/integration/reducer.js